import type { Accessory } from "@slfinrtl/ui-bff-routes"
import { ShowLuxuryTaxType, SpareWheelType } from "@slfinrtl/ui-bff-routes"
import type { IntlShape } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { pricingFieldMessages } from "../hooks"
import type { CanadaPriceBreakdownPricingFields } from "./canadaPriceBreakdownPricing.fields"
import { canadaPriceBreakdownPricingFieldNames } from "./canadaPriceBreakdownPricing.fields"

export const getCanadaPriceBreakdownPricingFields = (
	isDraft: boolean,
	availableAccessories: Accessory[] | undefined,
	modelSeriesKey: string | undefined,
	formatMessage: IntlShape["formatMessage"],
): CanadaPriceBreakdownPricingFields => {
	const accessories = availableAccessories?.filter(
		(accessory) =>
			accessory.restrictions.modelSeries === undefined ||
			(modelSeriesKey && accessory.restrictions.modelSeries.includes(modelSeriesKey)),
	)

	return {
		accessories: accessories
			? {
					items: accessories.map(({ id, label }) => ({
						label,
						value: id,
					})),
					name: canadaPriceBreakdownPricingFieldNames.accessoriesName,
				}
			: undefined,
		hasSpareWheel: {
			label: formatMessage(pricingFieldMessages.hasSpareWheelLabel),
			labelTooltip: formatMessage(pricingFieldMessages.hasSpareWheelHint),
			name: canadaPriceBreakdownPricingFieldNames.hasSpareWheelName,
			options: [
				{
					label: formatMessage(commonMessages.yes),
					value: SpareWheelType.YES,
				},
				{
					label: formatMessage(commonMessages.no),
					value: SpareWheelType.NO,
				},
			],
			required: true,
			withoutPreselection: true,
		},
		minimumPrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.minimumPriceLabel),
			name: canadaPriceBreakdownPricingFieldNames.minimumPriceName,
			type: "currency",
		},
		purchasePrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.purchasePriceLabel),
			name: canadaPriceBreakdownPricingFieldNames.purchasePriceName,
			type: "currency",
		},
		showLuxuryTax: {
			label: formatMessage(pricingFieldMessages.showLuxuryTaxLabel),
			name: canadaPriceBreakdownPricingFieldNames.showLuxuryTaxName,
			options: [
				{
					label: formatMessage(pricingFieldMessages.showLuxuryTaxYes),
					value: ShowLuxuryTaxType.YES,
				},
				{
					label: formatMessage(pricingFieldMessages.showLuxuryTaxNo),
					value: ShowLuxuryTaxType.NO,
				},
			],
			required: true,
			withoutPreselection: false,
		},
		vehiclePrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.vehiclePriceLabel),
			name: canadaPriceBreakdownPricingFieldNames.vehiclePriceName,
			required: true,
			type: "currency",
		},
	}
}
